import React from 'react'
import { EmployeePublicInfo } from '@/features/employee-data/employee-data.def.ts'
import { Alert, Spin } from 'antd'
import { EmptyData } from '@/common/types/misc.def.ts'
import { plainToInstance } from 'class-transformer'
import { ClassValue } from 'clsx'
import { EmployeeCard } from '@/common/components/EmployeeCard.tsx'
import { useEmployeePublicInfo } from '@/common/hooks/useEmployeePublicInfo.tsx'


export const EmployeeCompactCard: React.FC<{
  employeeId?: string | null,
  className?: ClassValue
  onClick?: React.MouseEventHandler<HTMLDivElement>
}> = ({ employeeId, className, onClick }) => {
  const { data, isLoading } = useEmployeePublicInfo()

  if (!employeeId) {
    return EmptyData.string
  }

  if (isLoading) {
    return <Spin />
  }

  const selectedEmployee = data?.find(x => x.employeeId === employeeId)

  if (!selectedEmployee) {
    return <Alert message={`Cannot load ${employeeId}`} type="error" />
  }

  const employee = plainToInstance(EmployeePublicInfo, selectedEmployee)

  return <EmployeeCard employeeId={employee.employeeId} className={className} onClick={onClick} />
}
